import React, { useState } from "react";
import PopUp from "../utils/PopUp";
import { toast } from "sonner";
import axios from "axios";

const HAnnouncement = ({ isVisible, onClose, id_user }) => {
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const api = `${process.env.REACT_APP_SERVER}/api/announcement/create`;
      const data = {
        title,
        description,
        type,
        id_user,
      };
      const query = await axios.post(api, data);
      toast.success("Success create announcement!");
      setTimeout(() => {
        
        window.location.reload()
      }, 300);
    } catch (error) {
      console.error("ERROR: ", error);
      toast.error("Failed create announcement!");
    }
  };
  return (
    <PopUp isVisible={isVisible} onClose={onClose} title={"Announcement"}>
      <input
        value={title}
        className="input mt-4 input-bordered w-full"
        type="text"
        placeholder="Title"
        onChange={(e) => setTitle(e.target.value)}
      ></input>
      <input
        value={description}
        className="input mt-4 input-bordered w-full"
        type="text"
        placeholder="Description"
        onChange={(e) => setDescription(e.target.value)}
      ></input>
      <div className="flex gap-4 mt-4 justify-between ">
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="select select-bordered w-full"
        >
          <option value={""} disabled>
            Type of Announcement
          </option>
          <option value={"Activity"}>Activity</option>
          <option value={"Leave"}>Leave</option>
          <option value={"Another"}>Another</option>
        </select>
        <div className="flex justify-center items-center bottom-0">
          <div
            onClick={handleSubmit}
            
            className="px-3 py-2 bg-amber-600 text-white cursor-pointer rounded-lg"
          >
            Submit
          </div>
        </div>
      </div>
    </PopUp>
  );
};

export default HAnnouncement;
